export const formatNumber = (number, precision = 2) => {
  return (
    number?.toLocaleString("en", {
      minimumFractionDigits: 0,
      maximumFractionDigits: precision,
    }) ?? "0"
  );
};

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const shotPixels = () => {
  if (!document.getElementById("bingUetScript")) {
    const bingUetScript = document.createElement("script");
    bingUetScript.id = "bingUetScript";
    bingUetScript.innerHTML = `
    function uet_report_conversion() {window.uetq = window.uetq || [];window.uetq.push('event', 'begin_checkout', {});}
    uet_report_conversion();`;
    document.head.appendChild(bingUetScript);
  }

  if (!document.getElementById("fbScript")) {
    const fbScript = document.createElement("script");
    fbScript.id = "fbScript";
    fbScript.innerHTML = `
           !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;
            n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '592433636853293'); 
            fbq('track', 'PageView'); 
            fbq('track', 'CompleteRegistration'); // Custom Event: Registration
         `;
    console.log("x2");
    document.head.appendChild(fbScript);
  }

  const fbNoScript = document.createElement("noscript");
  fbNoScript.id = "fbNoScript";
  fbNoScript.innerHTML = `
  <img height="1" width="1" style="display:none" 
  src="https://www.facebook.com/tr?id=592433636853293&ev=PageView&noscript=1"/>
`;
  document.head.appendChild(fbNoScript);
};

export const removePixels = () => {
  const bingUetScript = document.getElementById("bingUetScript");
  if (bingUetScript?.parentNode) {
    bingUetScript.parentNode.removeChild(bingUetScript);
  }

  const fbScript = document.getElementById("fbScript");
  if (fbScript?.parentNode) {
    fbScript.parentNode.removeChild(fbScript);
  }

  if (document.getElementById("fbPixelScript")) {
    document.head.removeChild(document.getElementById("fbPixelScript"));
  }
  if (document.getElementById("fbNoScript")) {
    document.head.removeChild(document.getElementById("fbNoScript"));
  }
};

export const shootGoogleTag = () => {
  window.gtag("event", "conversion", {
    send_to: "AW-11530121883/MJVVCJbepf4ZEJvl_vkq",
    value: 1.0,
    currency: "USD",
    // event_callback: () => {
    //   submittedConversion.current = true;
    // },facebook
  });
};

export const tagmanager = (elementId, googleId) => {
  if (!document.getElementById(elementId)) {
    const headerGtag = document.createElement("script");
    headerGtag.async = true;
    headerGtag.id = elementId;
    headerGtag.src = `https://www.googletagmanager.com/gtag/js?id=${googleId}`;
    document.head.appendChild(headerGtag);
  }

  if (!document.getElementById(`${elementId}Config`)) {
    const headerGtagConfig = document.createElement("script");
    headerGtagConfig.async = true;
    headerGtagConfig.id = `${elementId}Config`;
    headerGtagConfig.innerHTML = `
     window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${googleId}');
    `;
    document.head.appendChild(headerGtagConfig);
  }
};
